import React from "react";
import { useLocation } from "react-router-dom"; 

import image1InstantChecks from "../assets/icons/image1InstantChecks.png"; 
import image2InstantChecks from "../assets/icons/image2InstantChecks.png";
import image3InstantChecks from "../assets/icons/image3InstantChecks.png";

import image1BackgroundChecks from "../assets/icons/image1BackgroundChecks.png";
import image2BackgroundChecks from "../assets/icons/image2BackgroundChecks.png";
import image3BackgroundChecks from "../assets/icons/image3BackgroundChecks.png";

import image1dueDiligence from "../assets/icons/image1dueDiligence.png";
import image2dueDiligence from "../assets/icons/image2dueDiligence.png";
import image3dueDiligence from "../assets/icons/image3dueDiligence.png";
import { WhyChooseUsContainer, WhyChooseUsDescription, WhyChooseUsImageWrapper, WhyChooseUsRow, WhyChooseUsSubTitle, WhyChooseUsTextWrapper, WhyChooseUsTitle } from "../assets/styles/CommonStyles";

const sectionsData = {
  instantChecks: [
    {
      title: "Trusted API Integrations",
      subtitle: "Accurate Data, Seamless Integration",
      description:
        "Access a robust suite of 80+ trusted APIs to perform critical verifications-GST, PAN, Aadhaar, and beyond. Whether you need instant validation or seamless integration, our platform delivers reliable results efficiently. Reduce manual errors, ensure compliance, and gain the confidence to make data-driven decisions at lightning speed.",
      image: image1InstantChecks,
      reverse: false,
    },
    {
      title: "Instant Onboarding",
      subtitle: "No Delays, No Hassles",
      description:
        "Streamline your onboarding process with real-time KYC and instant verification. Verify employees, customers, and third parties without interruptions, ensuring smooth and efficient operations. With instant, reliable checks, say goodbye to waiting and hello to productivity. Our platform is designed to keep your business moving forward-fast and hassle-free.",
      image: image2InstantChecks,
      reverse: true,
    },
    {
      title: "Customizable Compliance",
      subtitle: "Flexibility to Meet Every Need",
      description:"Build a compliance framework tailored to your business. Start with essential checks and scale effortlessly into specialized areas like background verifications and due diligence. Our platform evolves with your needs, ensuring that both basic and complex regulatory requirements are met seamlessly. Stay compliant, stay confident.",
      image: image3InstantChecks,
      reverse: false,
    },
  ],
  backgroundChecks: [
    {
      title: "Accurate, In-Depth Validation",
      subtitle: "Empower Your Team with Trusted Insights",
      description:"Make confident decisions with our thorough, customized checks. From employees to external partners, we validate multiple variables, including employment history, education, criminal records, financial audits, and compliance assessments. With a proven process and meticulous attention to detail, we ensure every individual and business meets your specific parameters, empowering your team with reliable data for secure operations.",
      image: image1BackgroundChecks,
      reverse: false,
    },
    {
      title: "QuickStart Onboarding",
      subtitle: "Fast, Reliable Checks Without Delays",
      description:"Skip the lengthy wait for reports. Our streamlined approach ensures fast background verification, enabling instant onboarding and uninterrupted workflows. With Devia, you can confidently hire, onboard, and collaborate with the right people—all while meeting deadlines and maintaining accuracy.",
      image: image2BackgroundChecks,
      reverse: true,
    },
    {
      title: "Compliance You Can Trust",
      subtitle: "Devia goes beyond routine checks—we conduct in-depth background verifications to uphold the highest standards of integrity and security.",
      description:"Whether ensuring internal compliance or assessing third-party partnerships, our meticulous validation process safeguards your operations at every level. With every critical detail verified, you can focus on growth with confidence, knowing your business remains protected.",
      image: image3BackgroundChecks,
      reverse: false,
    },
  ],
  dueDiligence: [
    {
      title: "Our Approach to Due Diligence",
      subtitle: "Go Beyond the Surface-Make Decisions with Absolute Confidence.",
      description:"Devia’s due diligence platform equips you with deep, precise analysis, ensuring no critical detail goes unnoticed. Uncover hidden risks, validate key insights, and gain a 360-degree view of every entity you engage with. Our comprehensive checks empower you to act decisively, mitigate uncertainties, and drive smarter, data-backed decisions with unwavering confidence.",
      image: image1dueDiligence,
      reverse: false,
    },
    {
      title: "See the Full Picture-Drive Smarter Decisions with Confidence.",
      description:"Devia’s due diligence platform gives you unparalleled financial visibility, empowering you to assess risks and opportunities with precision. Our intuitive dashboard and deep-dive analytics provide a comprehensive evaluation of financial data, uncovering hidden risks and ensuring transparency in every partnership. With real-time insights and meticulous due diligence, you can navigate complex decisions with absolute clarity, control, and confidence.",
      image: image2dueDiligence,
      reverse: true,
    },
    {
      title: "Built on Compliance. Driven by Diligence. Powered for Success.",
      description:"At Devia, compliance isn’t just a requirement—it’s the foundation of everything we do. Our rigorous due diligence process ensures that every partnership, transaction, and decision aligns with the highest regulatory standards. We go beyond surface-level checks, meticulously analyzing every detail to minimize risk, enhance transparency, and safeguard your business. With compliance and diligence as our pillars, we empower you to operate with confidence, build trust, and achieve sustainable success.",
      image: image3dueDiligence,
      reverse: false,
    },
  ],
};

const WhyChooseUs = () => {
  const location = useLocation();

  const isInstantChecks = location.pathname.includes("instant-checks");
  const isBackgroundChecks = location.pathname.includes("background-checks");
  const isDueDiligence = location.pathname.includes("due-diligence");

  const currentSection = isInstantChecks
    ? sectionsData.instantChecks
    : isBackgroundChecks
    ? sectionsData.backgroundChecks
    : isDueDiligence
    ? sectionsData.dueDiligence
    : sectionsData.instantChecks;

  return (
    <WhyChooseUsContainer>
      {currentSection.map((section, index) => (
        <WhyChooseUsRow
          key={index}
          style={{ flexDirection: section.reverse ? "row-reverse" : "row" }}
        >
          <WhyChooseUsTextWrapper reverse={section.reverse} dueDiligence={isDueDiligence}>
            <WhyChooseUsTitle dueDiligence={isDueDiligence}>{section.title}</WhyChooseUsTitle>
            <WhyChooseUsSubTitle dueDiligence={isDueDiligence}>{section.subtitle}</WhyChooseUsSubTitle>
            <WhyChooseUsDescription>{section.description}</WhyChooseUsDescription>
          </WhyChooseUsTextWrapper>
          <WhyChooseUsImageWrapper src={section.image} alt={section.title} />
        </WhyChooseUsRow>
      ))}
    </WhyChooseUsContainer>
  );
};
export default WhyChooseUs;
